module.exports = __webpack_public_path__ + "static/media/sofa.f20afe3e.svg";